export class SelectedProductState {
  constructor(
    public isLoadingByBarcode = false,
    public isLoadingByProductId = false,
    public isSubmitting = false
  ) {}

  get isLoading(): boolean {
    return this.isLoadingByBarcode || this.isLoadingByProductId;
  }

  set isLoading(value: boolean) {
    this.isLoadingByBarcode = value;
    this.isLoadingByProductId = value;
  }
}
